module.exports = __webpack_public_path__ + "static/appTabImg2-4f1a17b8deeeea96cf3619289878cfa5.png";